class ShowMore extends HTMLElement {
  constructor() {
    super();
    this.showMoreListEl = null;
    this.showMoreButtonEl = null;
    this.showMoreAmountEl = null;
  }

  connectedCallback() {
    this.showMoreListEl = this.querySelector("[data-show-more='list']");
    this.showMoreButtonEl = this.querySelector("[data-show-more='button']");
    this.showMoreAmountEl = this.querySelector("[data-show-more-amount]");
    if (this.showMoreAmountEl) {
      if (this.showMoreListEl) {
        let visibleItemsCount = this.showMoreListEl.dataset.showMorePreview;
        if (typeof visibleItemsCount === "undefined") return;
        let hiddenItemsCount =
          this.showMoreListEl.children.length - parseInt(visibleItemsCount);
        this.showMoreAmountEl.dataset.showMoreAmount =
          hiddenItemsCount.toString();
      }
    }
    this.showMoreButtonEl.addEventListener(
      "click",
      this.revealItems.bind(this),
    );
  }

  disconnectedCallback() {
    this.showMoreButtonEl.removeEventListener("click", this.revealItems);
  }

  revealItems() {
    if (!this.classList.contains("show-more--reveal-items")) {
      this.classList.add("show-more--reveal-items");
    }
  }
}

if (!customElements.get("show-more")) {
  customElements.define("show-more", ShowMore);
}
